var _TO_DIR,indentLevelToClassName={0:"indentZero",1:"indentOne",2:"indentTwo",3:"indentThree",4:"indentFour",5:"indentFive",6:"indentSix"},TO_DIR=((_TO_DIR={}).LEFT="ltr",_TO_DIR.RIGHT="rtl",_TO_DIR);export{TO_DIR,indentLevelToClassName};
//# sourceMappingURL=consts.js.map
